export default "__VITE_PUBLIC_ASSET__9c1ec380__"